<script lang="ts">
  export let width: number = 130;
  export let height: number = 80;
  export let className: string = "";
  // Font Awesome solid icons preferred
  export let swimClass: string = "fa-solid fa-person-swimming";
  export let bikeClass: string = "fa-solid fa-person-biking"; // fallback could be fa-solid fa-bicycle
  export let runClass: string = "fa-solid fa-person-running";
</script>

<div class="relative" style={`width:${width}px;height:${height}px;`}>
  <svg
    {width}
    {height}
    viewBox="0 0 130 80"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Ironman passport stamp"
    class={className}
  >
    <title>Ironman Passport Stamp</title>

    <!-- Perforated ticket panel: outer rounded rectangle, dotted inner edge, inner rule -->
    <!-- Outer border -->
    <rect x="3" y="3" width="124" height="74" rx="10" ry="10" fill="none" stroke="#000" stroke-width="1.8" />

    <!-- Perforated edge (beaded dots) -->
    <rect x="6" y="6" width="118" height="68" rx="9" ry="9" fill="none" stroke="#000" stroke-width="1.2" stroke-linecap="round" stroke-dasharray="0.2 4.2" opacity="0.9" />

    <!-- Inner thin rule -->
    <rect x="10" y="10" width="110" height="60" rx="8" ry="8" fill="none" stroke="#000" stroke-width="0.8" opacity="0.9" />

    <!-- Central band for the title (black with low opacity to keep all-black constraint) -->
    <rect x="8" y="31" width="114" height="18" rx="4" ry="4" fill="#000" opacity="0.08" />

    <!-- IRONMAN text centered in the band, thickened with stroke -->
    <g transform="translate(65,40)">
      <text
        x="0"
        y="4"
        fill="#000"
        font-size="13"
        font-weight="900"
        text-anchor="middle"
        style="letter-spacing:2.5px;paint-order:stroke fill;stroke:#000;stroke-width:0.7;"
      >IRONMAN</text>
    </g>

    <!-- Small side dots near the band for extra ticket flair -->
    <circle cx="14" cy="40" r="1.2" fill="#000" opacity="0.8" />
    <circle cx="116" cy="40" r="1.2" fill="#000" opacity="0.8" />
  </svg>

  <!-- Font Awesome icon overlay (pure black, positioned above/below the band) -->
  <!-- Swim: top center -->
  <div class="absolute" style="top:8px;left:50%;transform:translateX(-50%);color:#000;">
    <i class={swimClass} style="font-size:18px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>

  <!-- Bike: bottom left-ish -->
  <div class="absolute" style="bottom:8px;left:35%;transform:translateX(-50%);color:#000;">
    <i class={bikeClass} style="font-size:18px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>

  <!-- Run: bottom right-ish -->
  <div class="absolute" style="bottom:8px;left:65%;transform:translateX(-50%);color:#000;">
    <i class={runClass} style="font-size:18px;line-height:1;color:#000;opacity:0.95;"></i>
  </div>
</div>
